import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { map, Observable, startWith } from 'rxjs';
import { FormioLoader } from 'dp-formio';

type DialogEventType = 'customEvent' | 'beforeSubmit' | 'submit';

@Component({
	selector: 'app-formio-dialog',
	templateUrl: './formio-dialog.component.html',
	styleUrls: ['./formio-dialog.component.scss'],
	providers: [FormioLoader],
})
export class FormioDialogComponent implements OnInit {
	eventType: DialogEventType = 'beforeSubmit';
	submission: Record<string, any>;
	formKey = '';

	dir$: Observable<any>;
	constructor(
		public dialogRef: MatDialogRef<FormioDialogComponent, any>,
		@Inject(MAT_DIALOG_DATA) public dialogData: any,
		public loader: FormioLoader,
		private translateService: TranslateService
	) {
		this.dir$ = (this.translateService.onLangChange as Observable<LangChangeEvent>).pipe(
			startWith({
				lang: this.translateService.currentLang,
			}),
			map((lang) => (lang.lang == 'ar' ? 'rtl' : 'ltr'))
		);
	}

	ngOnInit(): void {
		this.loader.loading = false;
		this.formKey = this.dialogData?.formKey;
		this.submission = this.dialogData?.submission;
		this.eventType = this.dialogData?.event;
	}

	cancel() {
		this.dialogRef.close();
	}
	customEvent(event: any) {
		if (event.component?.key == 'cancel') {
			this.dialogRef.close();
		}

		if (event.component?.key === 'submit' && this.eventType === 'customEvent') {
			this._closeAndEmitData(event.data, this.eventType);
		}
	}

	beforeSubmit(event: any) {
		if (this.eventType === 'beforeSubmit') {
			this._closeAndEmitData(event.data, this.eventType);
		}
	}
	submit(event: any) {
		if (this.eventType === 'submit') {
			this._closeAndEmitData(event.submission, this.eventType);
		}
	}


	private _closeAndEmitData(data: any, event: DialogEventType) {
		this.dialogRef.close({
			data: data,
			event: event,
		});
	}
}
